import alterar from '@/core/store/item-ata/alterar-fornecedor/alterar'
import historico from '@/core/store/item-ata/alterar-fornecedor/historico'

export default {
	modules: {
		alterar,
		historico,
	},
}
